import { useMutation } from "@tanstack/react-query";
import { Id, MutationOptions } from "PFTypes";

import { resetAuditEngagements } from "../../../../services/audit_planner";
import { auditEngagementsMutationKeys } from "./mutation_keys";

export const useResetEngagement = ({ onSuccess, ...options }: MutationOptions<Id> = {}) =>
  useMutation<unknown, unknown, Id>({
    mutationKey: auditEngagementsMutationKeys.reset(),
    mutationFn: (id: Id) => resetAuditEngagements([id]),
    onSuccess,
    ...options
  });
